import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import ICustomer, { ICustomerInput } from "@/interfaces/customer.interfaces";
import customerService from "@/services/customer.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateCustomerProps = {
  formData: ICustomerInput;
} & RequestsProps;

export type UseCreateCustomerReturn = {
  create: (props: CreateCustomerProps) => Promise<ICustomer>;
} & UseLoadingReturn;

const useCreateCustomer = (): UseCreateCustomerReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<ICustomerInput>({
    operation: (formData) => customerService.createCustomer(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateCustomer;
